const ChairishContext = window.chairisher.context;

/**
 * @returns {Object} Mapping of experiment keys to Variant objects
 */
export default function getAmplitudeExperimentKeyToVariantMap() {
    return ChairishContext.AMPLITUDE_EXPERIMENT_KEY_TO_VARIANT_MAP;
}
